export default __webpack_public_path__ + "static/media/SHR-2000-00.b78138f2.svg";